var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYingpanjiekou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.17064 8.42078H3.75044L4.61039 8.42507H14.93C15.1665 8.42507 15.36 8.61858 15.36 8.85501V14.0148C15.36 14.2513 15.1665 14.4448 14.93 14.4448H1.17064C0.934037 14.4448 0.740616 14.2513 0.740616 14.0148V8.8551C0.740616 8.61428 0.934036 8.42078 1.17064 8.42078ZM1.60057 13.5805H14.5V9.28073H1.60057V13.5805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54835 14.8238H8.12268C6.10239 14.8238 4.32112 13.499 3.73975 11.5642H12.814C12.2901 13.4885 10.5427 14.8238 8.54835 14.8238Z",
    fill: "#65C8FA",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96538 12.2648L6.75928 12.0856H9.79407C9.52203 12.503 9.05752 12.7547 8.55928 12.7547H8.27571C7.79415 12.7547 7.32881 12.5807 6.96538 12.2648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4118 8.75004L13.3894 2.70539C13.376 2.5522 13.277 2.45987 13.1582 2.45987H2.85345C2.73475 2.46002 2.63595 2.55254 2.62643 2.67237L1.62108 8.75004H0.699707L1.72128 2.56737C1.76533 2.00032 2.25914 1.53809 2.85289 1.53809H13.1578C13.7511 1.538 14.2451 1.99909 14.2931 2.5978L15.3334 8.75004H14.4118Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_2284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYingpanjiekou);
export default __webpack_public_path__ + "static/media/yingpanjiekou.d1219a1e2a2a0f3db9943d7c21be6181.svg";
export { ForwardRef as ReactComponent };